import styled, {css} from "styled-components";
import {Header, RingEmpty, RingFull} from "../landing.components";
import {responsive} from "../../../../media-quries";
import { BsBuildingsFill } from "react-icons/bs";
import { FaBalanceScaleRight } from "react-icons/fa";
import { FaExchangeAlt } from "react-icons/fa";
import { FaMoneyCheckAlt } from "react-icons/fa";
import buildings3 from '../../../../assets/buildings3.webp';
import tree3 from '../../../../assets/tree2.webp';

const Container = styled.div`
  margin: 32px 0;
  padding: 24px 0;
  display: flex;
  position: relative;
  min-height: 600px;
  flex-direction: column;
  gap: 40px;
`;
const TilesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
const Tile = styled.div`
  gap: 32px;
  display: flex;
  padding: 24px;
  flex-basis: 50%;
  transition: all 0.2s;
  flex-direction: column;
  align-items: center;

  &:hover {
    transform: scale(1.07);
  }

  ${responsive.md`
  flex-basis: 100%;
  `}

  ${responsive.sm`
  flex-basis: 100%;
  `}
`;
const TileCircle = styled.div`
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background-color: ${({ color }) => color};
  display: flex;
  align-items: center;
  justify-content: center;
  
  ${({ color }) => css`
    -webkit-box-shadow: 0px 8px 26px 0px ${color};
    -moz-box-shadow: 0px 8px 26px 0px ${color};
    box-shadow: 0px 8px 26px 0px ${color};
  `}
  
`;
const TileTitle = styled.h4`
  position: relative;
  font-size: 24px;
  font-weight: 600;
  text-align: center;
  
  &:after {
    content: "";
    border-bottom: ${({ color }) => `6px solid ${color}`};
    left: 20%;
    right: 20%;
    position: absolute;
    bottom: -30px;
  }
`;
const TileDescription = styled.p`
  margin-top: 24px;
  text-align: center;
`;
const BuildingImg = styled.img`
  position: absolute;
  right: -450px;
  top: calc(50% - 200px);

  ${responsive.lg`
    right: -400px;
  `}

  ${responsive.md`
    right: -380px;
  `}

  ${responsive.sm`
    display: none;
  `}
`
const Tree = styled.img`
  position: absolute;
  left: -100px;
  bottom: 40px;

  ${responsive.xxl`
    left: -200px;
  `}
`;
const Ring1 = styled(RingEmpty)`
  width: 120px;
  height: 120px;
  top: 0px;
  left: -50px;
`;
const Ring2 = styled(RingEmpty)`
  width: 90px;
  height: 90px;
  bottom: 30px;
  right: -50px;

  ${responsive.sm`
    display: none;
  `}
`;
const Ring3 = styled(RingFull)`
  width: 40px;
  height: 40px;
  top: 0;
  left: 60px;
`;
const Ring4 = styled(RingEmpty)`
  width: 140px;
  height: 140px;
  top: 600px;
  left: -150px;
`;
function When() {

    return <Container>
        <Header>Kiedy warto zapoznać się z księgą wieczystą</Header>
        <TilesContainer>
            <Tile>
                <TileCircle color="#43bc91">
                    <BsBuildingsFill size={60} color="#f5f5f5" />
                </TileCircle>
                <TileTitle color="#43bc91">
                    Przy zakupie nieruchomości
                </TileTitle>
                <TileDescription>
                    Sprawdzenie ksiąg wieczystych to podstawa przy kupnie mieszkania, domu czy działki. Weryfikacja dokumentu pozwala potwierdzić stan prawny i upewnić się, że sprzedający posiada pełne prawo własności – zarówno w tradycyjnej formie, jak i przy korzystaniu z elektronicznych ksiąg wieczystych online
                </TileDescription>
            </Tile>
            <Tile>
                <TileCircle color="#bc436e">
                    <FaBalanceScaleRight size={60} color="#f5f5f5" />
                </TileCircle>
                <TileTitle color="#bc436e">
                    Weryfikacja obciążeń i hipotek
                </TileTitle>
                <TileDescription>
                    Analiza ksiąg wieczystych umożliwia sprawdzenie ewentualnych obciążeń, takich jak służebności, egzekucje czy hipoteki. Użytkownicy serwisu mogą skorzystać z naszej wyszukiwarki ksiąg wieczystych, aby uniknąć nieprzyjemnych niespodzianek związanych z dodatkowymi zobowiązaniami prawnymi i finansowymi.
                </TileDescription>
            </Tile>
            <Tile>
                <TileCircle color="#436ebc">
                    <FaExchangeAlt size={60} color="#f5f5f5" />
                </TileCircle>
                <TileTitle color="#436ebc">
                    Rynek wtórny oraz transakcje spadkowe
                </TileTitle>
                <TileDescription>
                    W przypadku nieruchomości z rynku wtórnego lub przy transakcjach spadkowych, analiza elektronicznych ksiąg wieczystych online dostarcza niezbędnych informacji o aktualnym stanie prawnym. To kluczowy element, który pomaga w podjęciu świadomej decyzji inwestycyjnej.
                </TileDescription>
            </Tile>
            <Tile>
                <TileCircle color="#f3a712">
                    <FaMoneyCheckAlt size={60} color="#f5f5f5" />
                </TileCircle>
                <TileTitle color="#f3a712">
                    Planowany zakup z kredytem hipotecznym
                </TileTitle>
                <TileDescription>
                    Przy zakupie nieruchomości finansowanej kredytem, ważne jest sprawdzenie, czy wpis dotyczący hipoteki w księgach wieczystych online nie obciąża nieruchomości kwotą przewyższającą jej wartość. Nasza wyszukiwarka ksiąg wieczystych umożliwia szybkie porównanie i weryfikację tych danych, co stanowi kluczowy krok dla bezpiecznej transakcji.
                </TileDescription>
            </Tile>
        </TilesContainer>
        <BuildingImg src={buildings3} />
        <Tree src={tree3} />
        <Ring1 />
        <Ring3/>
        <Ring4/>
        <Ring2 />
    </Container>
}

export default When;
